import { AfterContentInit, Component, Input } from '@angular/core';
import { SortableTableDirective } from './sortable-table.directive';
import { SortDirection } from './sort-direction.model';
import { Sorter } from './sorter.model';

@Component({
    selector: 'th[columnKey]',
    templateUrl: 'sortable-column.component.html',
    styleUrls: ['sortable-column.component.scss'],
    standalone: false
})
export class SortableColumnComponent implements AfterContentInit {

    @Input() columnKey: string;
    @Input() default?: SortDirection;
    @Input() sorter: Sorter;
    direction: SortDirection;

    constructor(private sortableTable: SortableTableDirective) { }

    public toggle(direction: SortDirection): void {
        this.direction = direction;
        this.sortableTable.doSort(this.columnKey, direction, this.sorter);
    }

    public isActive() {
        return this.sortableTable.activeColumn === this.columnKey;
    }

    ngAfterContentInit(): void {
        if (this.default) {
            this.sortableTable.doSort(this.columnKey, this.default, this.sorter);
        }
    }
}
